import React from 'react';
import Button from '../../../components/ui/Button';

const DateRangeSelector = ({ selectedRange, onRangeChange, customDateRange, onCustomDateChange }) => {
  const presetRanges = [
    { label: '1M', value: '1M', days: 30 },
    { label: '3M', value: '3M', days: 90 },
    { label: '6M', value: '6M', days: 180 },
    { label: '1Y', value: '1Y', days: 365 },
    { label: 'All', value: 'All', days: null }
  ];

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      <div className="flex flex-wrap items-center gap-2 md:gap-3">
        <span className="text-sm md:text-base font-medium text-foreground mr-2">
          Time Period:
        </span>
        {presetRanges?.map((range) => (
          <Button
            key={range?.value}
            variant={selectedRange === range?.value ? 'default' : 'outline'}
            size="sm"
            onClick={() => onRangeChange(range?.value)}
            className="min-w-[60px] md:min-w-[70px]"
          >
            {range?.label}
          </Button>
        ))}
      </div>
      {selectedRange === 'custom' && (
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 p-4 bg-muted rounded-lg">
          <div className="flex-1">
            <label className="block text-sm font-medium text-foreground mb-2">
              Start Date
            </label>
            <input
              type="date"
              value={customDateRange?.start}
              onChange={(e) => onCustomDateChange('start', e?.target?.value)}
              className="w-full px-3 py-2 border border-input rounded bg-background text-foreground text-sm md:text-base"
              max={customDateRange?.end}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-foreground mb-2">
              End Date
            </label>
            <input
              type="date"
              value={customDateRange?.end}
              onChange={(e) => onCustomDateChange('end', e?.target?.value)}
              className="w-full px-3 py-2 border border-input rounded bg-background text-foreground text-sm md:text-base"
              min={customDateRange?.start}
              max={new Date()?.toISOString()?.split('T')?.[0]}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;